export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_10.146a17c9.mp4";